module.exports = __webpack_public_path__ + "img/shape-3.fc1b0b53.png";